// export this package's api
import Drawer from './DrawerWrapper';
export default Drawer;


//////////////////
// WEBPACK FOOTER
// ../~/_rc-drawer@2.0.9@rc-drawer/es/index.js
// module id = 1311
// module chunks = 0